module.exports = __webpack_public_path__ + "static/media/home_10.0c37bd56.jpg";